import PropTypes from 'prop-types';
import React from 'react';

import { ReactComponent as Check } from '../../assets/check.svg';
import { rmdDashboardLink } from '../../utils/constants';
import { getFAQSubText, RMD_SUBJECT } from '../MessageCompositionBody/faqUtil';
import styles from './ComposeFAQ.module.scss';

const ComposeFAQ = ({ faqItems, env, selectedSubject = '' }) => {
  const dynamicSubText = getFAQSubText(faqItems, selectedSubject);

  return (
    <aside className={`faq ${styles['faq-body']}`}>
      <div className={styles['faq-content']}>
        <p className={`${styles['header-text']} branded-text`}>
          Have a quick question?
        </p>
        <p className={`$styles['body-text']} branded-text`}>
          <span dangerouslySetInnerHTML={{ __html: dynamicSubText }} />
        </p>
        <ul>
          {selectedSubject === RMD_SUBJECT &&
            <div className={styles['rmd-faq-container']}>
              <a className={styles['rmd-faq-link']}
                 href={rmdDashboardLink[env]}>Visit your RMD dashboard</a>
              <div className={styles['rmd-faq-intro']}>You can:</div>
              <div className={styles['rmd-faq-list-item']}> <Check className={styles['rmd-faq-check']}/>View your RMD amount</div>
              <div className={styles['rmd-faq-list-item']}> <Check className={styles['rmd-faq-check']}/>Set up & edit your Auto-RMD</div>
              <div className={styles['rmd-faq-list-item']}> <Check className={styles['rmd-faq-check']}/>View your year-to-date IRA distribution amount</div>
              <div className={styles['rmd-faq-list-item']}> <Check className={styles['rmd-faq-check']}/>Update your tax withholding election for your automatic IRA withdrawal agreement</div>
              <div className={styles['rmd-faq-list-item']}> <Check className={styles['rmd-faq-check']}/>Take a Qualified Charitable Distribution (QCD)</div>
            </div>
          }
          {selectedSubject !== RMD_SUBJECT && faqItems.map(({ label, url }) =>
            <li className={styles['faq-list-item']} key={label}>
                    <a
                      className="faq-link"
                      href={url}
                      id={`faq-item-${label.replace(/ /g, '-')}`}
                      rel="noreferrer noopener"
                      target="_blank"
                    >
                      {label}
                    </a>
                  </li>
          )}
        </ul>
      </div>
    </aside>
  );
};

ComposeFAQ.propTypes = {
  env: PropTypes.string,
  faqItems: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      url: PropTypes.string
    })
  ),
  openModal: PropTypes.func,
  selectedSubject: PropTypes.string
};

export default ComposeFAQ;
